/** sonner toasts with messages translated at call time (English keys). */
import { toast as sonner } from 'sonner';

import { i18next } from '@/i18n';

type Options = Parameters<typeof sonner>[1];
const tr = (message: string, values?: Record<string, unknown>) => i18next.t(message, values ?? {});

export const toast = Object.assign(
  (message: string, options?: Options) => sonner(tr(message), options),
  {
    success: (message: string, options?: Options) => sonner.success(tr(message), options),
    error: (message: string, options?: Options) => sonner.error(tr(message), options),
    info: (message: string, options?: Options) => sonner.info(tr(message), options),
    warning: (message: string, options?: Options) => sonner.warning(tr(message), options),
  },
);
